var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, } from "@mui/material";
import { useState } from "react";
import { SearchPlayerResults } from "./SearchPlayerResults";
import { SearchTeamResults } from "./SearchTeamResults";
export default function Search() {
    var _a = __read(useState("team"), 2), searchType = _a[0], setSearchType = _a[1];
    return (_jsxs(Box, { p: 2, children: [_jsxs(FormControl, { component: "fieldset", children: [_jsx(FormLabel, { component: "legend", children: "Search for" }), _jsxs(RadioGroup, { row: true, value: searchType, onChange: function (e) { return setSearchType(e.target.value); }, children: [_jsx(FormControlLabel, { value: "team", control: _jsx(Radio, {}), label: "Teams" }), _jsx(FormControlLabel, { value: "player", control: _jsx(Radio, {}), label: "Players" })] })] }), _jsx(Box, { mt: 2, children: searchType === "team" ? (_jsx(SearchTeamResults, {})) : (_jsx(SearchPlayerResults, {})) })] }));
}
